import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {environment} from "../../../environments/environment"
import {LaravelPaginationLink} from "../../laravel-pagination-link";
import {Station} from "../../station";
import {StationDialogComponent} from "./station-dialog/station-dialog.component";


@Component({
    selector: 'app-stations',
    templateUrl: './stations.component.html',
    styleUrls: ['./stations.component.scss']
})
export class StationsComponent implements OnInit {

    paginationLinks: LaravelPaginationLink[] = [];
    currentPage;
    totalResults;
    totalPages;
    currentLink = environment.APP_ENVIRONMENT + environment.STATIONS_ENDPOINT;
    rows: Station[] = [];
    displayedColumns: string[] = ['id', 'name', 'code', 'shop', 'actions'];

    constructor(
        public dialog: MatDialog,
        private http: HttpClient
    ) { }

    ngOnInit(): void {
        this.reloadTable();
    }

    createStationFromJson(json: any): Station
    {
        let result = new  Station();
        result.cloneFrom(json);
        return result;
    }

    reloadTable() {
        this.http.get<any>(this.currentLink).subscribe(response => {
                this.rows = response.data.map(this.createStationFromJson);
                this.currentPage = response.current_page;
                this.paginationLinks = response.links;
                this.totalPages = response.last_page;
                this.totalResults = response.total;
            },
            (err) => {
                console.dir(err);
            });
    }

    editStation(station: Station, callback: CallableFunction = () => {}) {
        const dialogRef = this.dialog.open(StationDialogComponent, {
                hasBackdrop: true,
                data: station
            }
        );
        dialogRef.afterClosed().subscribe(result => {
            callback(result)
        })
    }

    changePage(link) {
        this.currentLink = link;
        this.reloadTable();
    }

    createStation() {
        let station = new  Station();
        this.editStation(station, (result) => {
            this.reloadTable();
        })
    }

    deleteStation(station: Station) {
        this.http.post<any>(environment.APP_ENVIRONMENT+environment.STATIONS_ENDPOINT+"/delete/"+station.id_station, {}).subscribe(response => {
                if(!response.success)
                    console.dir(response.error);
                else {
                    this.reloadTable();
                }
            },
            (err) => {
                console.dir(err);
            });
    }
}
